import { getQueryParams } from "@crystal/core";
import "react";
import "../state/reducers.js";
import "../state/actions.js";
import "../state/utils.js";
import "../store/storage/memory-storage.js";
import "mitt";
import "../store/storage/universal-memory-storage.js";
import "@reduxjs/toolkit";
import "../store/state/host.js";
import "../store/state/modal.js";
import { getRuntimeInfo } from "../integration/state-getters.js";
import "../api/email-detection.js";
import "@account/configs";
import "@crystal/glass-bridge";
import "@crystal/http";
import "@crystal/recaptcha";
import "@crystal/analytics";
import "./source-ids.js";
import "./presets.js";
import "../ap2/config.js";
import "../ap2/state.js";
import "../external-auth/config.js";
import "@crystal/config";
function getUniversalAuthParams() {
  const errors = [];
  const { client_id, redirect_uri, response_type, source, state } = getQueryParams();
  if (!client_id) {
    errors.push("client_id");
  }
  if (!redirect_uri) {
    errors.push("redirect_uri");
  }
  if (response_type !== "code") {
    errors.push("response_type");
  }
  if (!source) {
    errors.push("source");
  }
  if (errors.length) {
    throw new Error(`Invalid params: ${errors.join(", ")}`);
  }
  return {
    clientId: client_id,
    redirectUri: redirect_uri,
    responseType: response_type,
    sourceId: source,
    state
  };
}
function isAuthProvider() {
  return !!getRuntimeInfo().isAuthProvider;
}
export {
  getUniversalAuthParams,
  isAuthProvider
};
//# sourceMappingURL=universal-auth.js.map
